module.exports = __webpack_public_path__ + "static/media/auGovLogo.57416679.png";